import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ITokenData, TokenKind } from "common/records/Token";
import { IAuthorizedTokenData } from "common/records/AuthorizedToken";
import { Nullable } from "common/types";

export const FETCH_AUTHORIZED = "@tokens/FETCH_AUTHORIZED";
export const RECEIVE_AUTHORIZED = "@tokens/RECEIVE_AUTHORIZED";
export const SET_AUTHORIZED_LOADED = "@tokens/SET_AUTHORIZED_LOADED";
export const RECEIVE_TOKEN = "@tokens/RECEIVE_TOKEN";
export const RECEIVE_TOKENS = "@tokens/RECEIVE_TOKENS";
export const FETCH_TOKEN = "@tokens/FETCH_TOKEN";
export const SET_LOADED = "@tokens/SET_LOADED";
export const ADD_FILTER = "@tokens/ADD_FILTER";
export const REMOVE_FILTER = "@tokens/REMOVE_FILTER";
export const ADD_FILTER_VALUE = "@tokens/ADD_FILTER_VALUE";
export const REMOVE_FILTER_VALUE = "@tokens/REMOVE_FILTER_VALUE";
export const RESET_TOKEN = "@tokens/RESET_TOKEN";
export const REMOVE_TOKEN = "@tokens/REMOVE_TOKEN";
export const ADD_DATA_ITEM = "@tokens/ADD_DATA_ITEM";
export const REMOVE_DATA_ITEM = "@tokens/REMOVE_DATA_ITEM";
export const ADD_ACTIVE_MANUFACTURER = "@tokens/ADD_ACTIVE_MANUFACTURER";
export const REMOVE_ACTIVE_MANUFACTURER = "@tokens/REMOVE_ACTIVE_MANUFACTURER";
export const CREATE_AVAILABLE_MANUFACTURER = "@tokens/CREATE_AVAILABLE_MANUFACTURER";
export const REMOVE_AVAILABLE_MANUFACTURER = "@tokens/REMOVE_AVAILABLE_MANUFACTURER";
export const ON_SORT_END = "@tokens/ON_SORT_END";
export const EDIT_TOKEN = "@tokens/EDIT_TOKEN";
export const ADD_IMAGE_ID = "@tokens/ADD_IMAGE_ID";

export const TokenActions = {
  receiveToken: (orgId: number, token: Partial<ITokenData>) => createAction(RECEIVE_TOKEN, { orgId, token }),
  receiveTokens: (orgId: number, tokens: Partial<ITokenData>[]) => createAction(RECEIVE_TOKENS, { orgId, tokens }),
  fetchToken: (orgId: number, tokenKind: TokenKind) => createAction(FETCH_TOKEN, { orgId, tokenKind }),
  resetToken: (orgId: number, tokenKind: TokenKind) => createAction(RESET_TOKEN, { orgId, tokenKind }),
  removeToken: (orgId: number, tokenKind: TokenKind) => createAction(REMOVE_TOKEN, { orgId, tokenKind }),
  fetchAuthorized: (orgId: number) => createAction(FETCH_AUTHORIZED, orgId),
  setLoaded: (orgId: number, tokenKind: TokenKind) => createAction(SET_LOADED, { orgId, tokenKind }),
  receiveAuthorized: (orgId: number, authorized: { [k in TokenKind]: IAuthorizedTokenData }) =>
    createAction(RECEIVE_AUTHORIZED, { orgId, authorized }),
  setAuthorizedLoaded: (orgId: number) => createAction(SET_AUTHORIZED_LOADED, orgId),
  addFilter: (orgId: number, tokenKind: TokenKind) => createAction(ADD_FILTER, { orgId, tokenKind }),
  removeFilter: (orgId: number, tokenKind: TokenKind, filterIndex: number) =>
    createAction(REMOVE_FILTER, { orgId, tokenKind, filterIndex }),
  addFilterValue: (orgId: number, tokenKind: TokenKind, filterIndex: number, valueIndex: number) =>
    createAction(ADD_FILTER_VALUE, { orgId, tokenKind, filterIndex, valueIndex }),
  removeFilterValue: (orgId: number, tokenKind: TokenKind, filterIndex: number, valueIndex: number) =>
    createAction(REMOVE_FILTER_VALUE, { orgId, tokenKind, filterIndex, valueIndex }),
  addDataItem: (orgId: number, tokenKind: TokenKind, itemName: string, newItem: any) =>
    createAction(ADD_DATA_ITEM, { orgId, tokenKind, itemName, newItem }),
  removeDataItem: (orgId: number, tokenKind: TokenKind, itemName: string, index: number) =>
    createAction(REMOVE_DATA_ITEM, { orgId, tokenKind, itemName, index }),
  addActiveManufacturer: (orgId: Nullable<number>, manufacturerId: string) =>
    createAction(ADD_ACTIVE_MANUFACTURER, { orgId, manufacturerId }),
  removeActiveManufacturer: (orgId: Nullable<number>, manufacturerId: string) =>
    createAction(REMOVE_ACTIVE_MANUFACTURER, { orgId, manufacturerId }),
  createAvailableManufacturer: (orgId: Nullable<number>, manufacturerId: string) =>
    createAction(CREATE_AVAILABLE_MANUFACTURER, { orgId, manufacturerId }),
  removeAvailableManufacturer: (orgId: Nullable<number>, manufacturerId: string) =>
    createAction(REMOVE_AVAILABLE_MANUFACTURER, { orgId, manufacturerId }),
  onSortEnd: (orgId: Nullable<number>, oldIndex: number, newIndex: number) =>
    createAction(ON_SORT_END, { orgId, oldIndex, newIndex }),
  editToken: (orgId: number, tokenKind: TokenKind, path: any[], value: any) =>
    createAction(EDIT_TOKEN, { orgId, tokenKind, path, value }),
  addImageId: (orgId: number, tokenKind: TokenKind, imageId: number) =>
    createAction(ADD_IMAGE_ID, { orgId, tokenKind, imageId }),
};

export type TokenActions = ActionsUnion<typeof TokenActions>;
